export const VIN_BODY_TYPE_ALIASES = {
  suv: "SUV",
  "sport utility vehicle": "SUV",
  crossover: "SUV",
  truck: "Truck",
  pickup: "Truck",
  van: "Van",
  minivan: "Van",
  sedan: "Sedan",
  saloon: "Sedan",
  bus: "Bus",
  car: "Car",
  hatchback: "Hatchback",
  coupe: "Car",
  wagon: "Car",
  "heavy truck": "Heavy Truck",
  "refrigerated truck": "Refrigerated Truck",
  ambulance: "Ambulance",
};

const VIN_DETAIL_SKIP_KEYS = new Set([
  "status",
  "statusCode",
  "message",
  "data",
]);

export const parseVinDecoderResponse = (responseData) => {
  if (!responseData || typeof responseData !== "object") return null;
  if (responseData.statusCode === "400" || responseData.statusCode === 400) {
    return null;
  }
  if (responseData.data && typeof responseData.data === "object") {
    return responseData.data;
  }
  if (responseData.vin || responseData.maker || responseData.make) {
    return responseData;
  }
  return null;
};

export const resolveVinCategory = (bodyType) => {
  if (!bodyType) return "";
  const normalized = String(bodyType).toLowerCase().trim();
  if (VIN_BODY_TYPE_ALIASES[normalized]) {
    return VIN_BODY_TYPE_ALIASES[normalized];
  }
  return String(bodyType).trim();
};

export const normalizeVinFuelType = (fuelType) => {
  if (!fuelType) return "";
  const normalized = String(fuelType).toUpperCase().trim();
  const map = {
    GASOLINE: "PETROL",
    GAS: "PETROL",
    PETROL: "PETROL",
    DIESEL: "DIESEL",
    ELECTRIC: "ELECTRIC",
    HYBRID: "HYBRID",
    PHEV: "PHEV",
    "PLUG-IN HYBRID": "PHEV",
    CNG: "CNG",
    LPG: "LPG",
    HYDROGEN: "HYDROGEN",
    ETHANOL: "ETHANOL",
    BIODIESEL: "BIODIESEL",
    FLEX: "OTHERS",
    OTHER: "OTHERS",
    OTHERS: "OTHERS",
  };
  return map[normalized] || normalized;
};

export const normalizeVinTransmission = (transmission) => {
  if (!transmission) return "";
  const normalized = String(transmission).toLowerCase();
  if (normalized.includes("auto")) return "Automatic";
  if (normalized.includes("manual")) return "Manual";
  return String(transmission).trim();
};

export const formatVinDetailKey = (key) => {
  return String(key)
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
};

export const getVinDetailLabel = (key) => formatVinDetailKey(key);

export const formatVinDetailValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const getVinDetailEntries = (vehicleData) => {
  if (!vehicleData || typeof vehicleData !== "object") return [];

  const entries = [];
  const seen = new Set();

  const pushEntry = (key, value) => {
    if (!key || VIN_DETAIL_SKIP_KEYS.has(key) || seen.has(key)) return;
    if (value === null || value === undefined || value === "") return;
    if (typeof value === "object") return;
    seen.add(key);
    entries.push({
      key,
      label: getVinDetailLabel(key),
      value: formatVinDetailValue(value),
    });
  };

  Object.entries(vehicleData).forEach(([key, value]) => {
    if (key === "settings" && value && typeof value === "object") {
      Object.entries(value).forEach(([settingKey, settingValue]) => {
        pushEntry(settingKey, settingValue);
      });
      return;
    }
    pushEntry(key, value);
  });

  return entries;
};

export const getVinConfirmPreview = (vehicleData) => {
  if (!vehicleData) return "";
  const maker = vehicleData.maker || vehicleData.make || "";
  const model =
    vehicleData.model || vehicleData.modelName || vehicleData.modelId || "";
  const year = vehicleData.modelYear || vehicleData.year || "";
  return [maker, model, year].filter(Boolean).join(" · ");
};
